export function retryLazy(fn, retriesLeft = 3, interval = 1000) {
    return new Promise((resolve, reject) => {
      fn()
        .then(resolve)
        .catch((error) => {
          if (retriesLeft === 1) {
            return reject(error);
          }
          setTimeout(() => {
            retryLazy(fn, retriesLeft - 1, interval).then(resolve, reject);
          }, interval);
        });
    });
  }